import {segment} from './helpers'

export const startedRegistration = (origin) => segment('Started Registration', {origin})
